package com.wintermar.inspection.feature.presentation.inspection.answer.widget

import androidx.compose.animation.animateContentSize
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Icon
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import com.wintermar.inspection.core.ui.component.TextBodySmall
import com.wintermar.inspection.core.ui.component.TextBodyTiny
import com.wintermar.inspection.core.ui.theme.AppDimension
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.core.ui.theme.color.model.ThemeColor
import com.wintermar.inspection.core.ui.util.modifier.borderExceptTop
import com.wintermar.inspection.feature.presentation.inspection.answer.InspectionAnswerState
import inspection.composeapp.generated.resources.Res
import inspection.composeapp.generated.resources.ic_arrow_down
import inspection.composeapp.generated.resources.ic_arrow_up
import org.jetbrains.compose.resources.painterResource

@Composable
fun HeaderProgress(
    state: InspectionAnswerState,
    withBorder: Boolean,
    color: ThemeColor = LocalAppTheme.current.color,
    dimension: AppDimension = LocalAppTheme.current.dimension
) {
    Column(
        modifier = Modifier
            .padding(bottom = if (withBorder) dimension.spacing.space4 else 0.dp)
            .fillMaxWidth()
            .background(color.surface.neutral.subtlest.default)
            .then(
                if (withBorder) Modifier.borderExceptTop(
                    color = color.border.subtle,
                    bottomLeftRadius = dimension.radius.md,
                    bottomRightRadius = dimension.radius.md
                )
                else Modifier
            )
            .clickable {
                state.onShowModalPageInfo(true)
            }
            .padding(
                horizontal = dimension.spacing.space4,
                vertical = dimension.spacing.space3
            ),
        verticalArrangement = Arrangement.spacedBy(dimension.spacing.space1)
    ) {
        Row(
            modifier = Modifier.fillMaxWidth().animateContentSize(),
            horizontalArrangement = Arrangement.spacedBy(dimension.spacing.space1)
        ) {
            TextBodyTiny(
                text = "${state.pageOrder + 1} of ${state.template.numberOfPages}",
                color = { it.subtle },
                modifier = Modifier.padding(top = 2.dp)
            )
            TextBodySmall(
                text = state.page.title.trim(),
                modifier = Modifier.weight(1f),
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
            Icon(
                painter = painterResource(if (state.modalPageInfo) Res.drawable.ic_arrow_up else Res.drawable.ic_arrow_down),
                tint = color.icon.subtle,
                contentDescription = state.page.title.trim()
            )
        }
        if (state.template.numberOfPages > 0) {
            InspectionAnswerProgress(
                state = state
            )
        }
    }
}
